import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    analyzing: 'Analyse des informations',
    eta: 'Moins d’une minute restante...',
    processing: 'Traitements des données',
    takingEvenLonger: 'Traitement toujours en cours, merci de patienter...',
    takingLonger: 'Le traitement est plus long que prévu...',
  },

  fr: {
    analyzing: 'Analyse des informations',
    eta: 'Moins d’une minute restante...',
    processing: 'Traitements des données',
    takingEvenLonger: 'Traitement toujours en cours, merci de patienter...',
    takingLonger: 'Le traitement est plus long que prévu...',
  },
});

export default locales;
